module.exports = __webpack_public_path__ + "static/media/IMG_3276.5dfab276.JPG";